import { environment } from "src/environments/environment";
import {
  createInterceptorCondition,
  INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
  IncludeBearerTokenCondition,
  provideKeycloak,
} from "keycloak-angular";

const escapedUrl = environment.backendUrl
  .replace(/\./g, "\\.")
  .replace(/\//g, "\\/");

const apiCondition = createInterceptorCondition<IncludeBearerTokenCondition>({
  urlPattern: new RegExp(`^${escapedUrl}(\/.*)?$`, "i"),
});

export const keycloakProvider = () =>
  provideKeycloak({
    config: {
      url: environment.keycloakUrl,
      realm: "horizon-view",
      clientId: "platform",
    },
    initOptions: {
      onLoad: "check-sso",
    },
    providers: [
      {
        provide: INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
        useValue: [apiCondition],
      },
    ],
  });
